export enum SectionThemeKey {
  Dark = 'Dark',
  Light = 'Light',
}
